/* unplugin-vue-components disabled */import { render } from "./HelloWorld.vue?vue&type=template&id=8afeffd4&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=8afeffd4&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/jhb-frontend-h5-prd/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8afeffd4"]])

export default __exports__